<div class="login">
    <div class="login__card">
        <form class="login__form">
            <img class="login__logo" src="/assets/img/Automation/logo.svg" alt="logo" />

            <h1 class="login__title">כניסה למערכת</h1>

            <div class="login__inputs">
                <div
                    class="login__input-wrapper input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isEmailValid || isInvalidCredentialsErrorVisible
                    }"
                >
                    <input
                        class="input"
                        [(ngModel)]="user.useremail"
                        name="email"
                        #email="ngModel"
                        type="email"
                        required
                        placeholder="Email address"
                        inputmode="email"
                        pattern="^(?!.*\.\.)([a-zA-Z0-9_%+\-]+(?:\.[a-zA-Z0-9_%+\-]+)*)@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,}$"
                    />
                </div>

                <div
                    class="login__input-wrapper input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isEmailValid || isInvalidCredentialsErrorVisible
                    }"
                >
                    <input
                        class="input"
                        [(ngModel)]="user.userpassword"
                        name="password"
                        #password="ngModel"
                        type="password"
                        required
                        placeholder="Password"
                    />
                </div>
            </div>

            <div *ngIf="!isEmailValid" class="login__error">מייל לא תקין</div>
            <div *ngIf="isInvalidCredentialsErrorVisible" class="login__error">שם משתמש ו/או סיסמה שגויים</div>
            <div *ngIf="hasErrorOccured" class="login__error">אופס, אין לך חיבור לאינטרנט</div>
            <div *ngIf="isTokenExpired" class="login__error">המערכת התנתקה עקב חוסר שימוש.נא להתחבר מחדש</div>

            <button class="login__button button button_size_small button_theme_main" (click)="goMainSms()">התחבר/י</button>
        </form>
    </div>
</div>
